/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReferralsSection/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Heading from './Heading/index'
import New from './New/index'
import React from 'react'
import Referrals from './Referrals/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ReferralsSection({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/ReferralsSection"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="ReferralsSection.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-L1x6k': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Heading
  viewPath={`${viewPath}/Heading`}
/>
<Referrals
  viewPath={`${viewPath}/Referrals`}
/>
<New
  viewPath={`${viewPath}/New`}
/>
</div>
{children}
</React.Fragment>)
}